import type { ReactNode } from 'react';
import { InfoBadge } from './InfoBadge';

interface DashboardPanelProps {
  title: string;
  subtitle?: string;
  info?: string;
  description?: string;
  children?: ReactNode;
  className?: string;
}

export function DashboardPanel({
  title,
  subtitle,
  info,
  description,
  children,
  className = '',
}: DashboardPanelProps) {
  return (
    <section className={`rounded-md border border-line bg-panel p-3 ${className}`}>
      <h2 className="flex items-center gap-2.5 text-[14.5px] font-semibold uppercase tracking-[0.02em] text-fg">
        {title}
        {subtitle != null && subtitle !== '' && (
          <span className="text-[13px] font-normal normal-case tracking-normal text-subtle">
            ({subtitle})
          </span>
        )}
        {info != null && info !== '' && <InfoBadge title={info} />}
      </h2>
      {description != null && description !== '' && (
        <p className="mt-1 text-xs text-soft">{description}</p>
      )}
      {children}
    </section>
  );
}
